import { forwardRef, useMemo, useState } from 'react'

import { Textarea, TextareaRef } from 'core-components/library/inputs'

import { IValidateTextareaProps } from './models/IValidateTextareaProps'
import { ValidationStatus } from './models/IValidationStatus'
import { Validator } from './Validator'

export const ValidateTextarea = forwardRef<TextareaRef, IValidateTextareaProps>(
  (props: IValidateTextareaProps, ref) => {
    const [validateStatus, setValidateStatus] = useState<ValidationStatus>(ValidationStatus.Valid)
    const valueDependencies = useMemo(() => {
      if (props.valueDependencies) {
        return props.valueDependencies
      }
      return [props.disabled]
    }, [props.disabled, props.valueDependencies])

    return (
      <Validator
        classes={props.classes?.validatorClasses}
        throttle={props.throttle}
        value={props.value}
        checkFn={props.disabled ? null : props.checkFn}
        valueDependencies={valueDependencies}
        tooltipVisible={props.tooltipVisible}
        onChangeValidation={(status) => setValidateStatus(status)}
      >
        <Textarea
          {...props}
          ref={ref}
          classes={props.classes?.inputClasses}
          wrapper={validateStatus === ValidationStatus.Invalid ? 'danger' : 'normal'}
        />
      </Validator>
    )
  }
)
